import { Controller } from "@hotwired/stimulus";

// Lecteur de tuto avec chapitres : un clic sur un chapitre saute au bon moment,
// et le chapitre en cours reste surligné pendant la lecture.
export default class extends Controller {
  static targets = ["video", "chapter"];
  static classes = ["active", "inactive"];

  seek({ params: { start } }) {
    this.videoTarget.currentTime = start;
    this.highlight();
    this.videoTarget.play().catch(() => {});
  }

  highlight() {
    const time = this.videoTarget.currentTime;
    let current = null;
    this.chapterTargets.forEach((chapter) => {
      if (Number(chapter.dataset.videoChaptersStartParam) <= time) current = chapter;
    });
    this.chapterTargets.forEach((chapter) => {
      const isCurrent = chapter === current;
      this.activeClasses.forEach((name) => chapter.classList.toggle(name, isCurrent));
      this.inactiveClasses.forEach((name) => chapter.classList.toggle(name, !isCurrent));
      chapter.setAttribute("aria-current", isCurrent ? "true" : "false");
    });
  }
}
